import { Expose } from 'class-transformer';
import { UserRole, UserStatus } from '../../enums';

export class UserResponseDto {
    @Expose()
    id: string;

    @Expose()
    email: string;

    @Expose()
    firstName: string | null;

    @Expose()
    lastName: string | null;

    @Expose()
    role: UserRole;

    @Expose()
    status: UserStatus;

    @Expose()
    createdAt: Date;

    @Expose()
    updatedAt: Date;
}
